export default __webpack_public_path__ + "land-use-plan-500-9603bb0bd0d71ef61974c8099777729e.webp";